import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import ItemList from 'flarum/common/utils/ItemList';
export default class ComposeHero extends Component {
  view() {
    const {
      item,
      translationPrefix,
      className
    } = this.attrs;
    const isEditing = !!item.id();
    return m("div", {
      className: "".concat(className, " Hero")
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h2", {
      className: "Hero-title"
    }, app.translator.trans("".concat(translationPrefix, ".").concat(isEditing ? 'edit' : 'add', "_title"))), m("div", {
      className: "".concat(className, "-controls")
    }, this.controlItems().toArray()))));
  }
  controlItems() {
    const items = new ItemList();
    const {
      item,
      managerRoute,
      managerIcon,
      managerLabel,
      viewRoute,
      viewIcon,
      viewLabel
    } = this.attrs;
    items.add('manager', m(LinkButton, {
      icon: managerIcon,
      className: "Button Button--secondary",
      itemClassName: "App-primaryControl",
      href: app.route(managerRoute)
    }, managerLabel));
    if (item.exists && viewRoute && viewLabel) {
      items.add('view', m(LinkButton, {
        icon: viewIcon || 'far fa-arrow-up-right-from-square',
        className: "Button Button--secondary",
        itemClassName: "App-primaryControl",
        href: app.route(viewRoute, {
          id: item.id()
        })
      }, viewLabel));
    }
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/ComposeHero', ComposeHero);